"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ContainerFormTipologia = void 0;

var _react = _interopRequireDefault(require("react"));

var _style = _interopRequireDefault(require("./style"));

var _material = require("@mui/material");

var _FormTipologia = _interopRequireDefault(require("./FormTipologia"));

var _CardTipologia = _interopRequireDefault(require("../CardTipologia"));

var _housesAnimate = _interopRequireDefault(require("../../images/houses-animate.svg"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ContainerFormTipologia extends _react.default.Component {
  constructor(props) {
    super(props);
    this.eliminarTipologia = this.eliminarTipologia.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onCancelarAlertEliminar = this.onCancelarAlertEliminar.bind(this);
    this.onAgregarTipologiaAlertEliminar = this.onAgregarTipologiaAlertEliminar.bind(this);
    this.guardar = this.guardar.bind(this);
    let primeraVez = {
      value: false,
      idTipologia: null,
      idUnidad: null
    };

    if (this.props.tipologias.length == 1) {
      this.props.tipologias.forEach(function (tipologia) {
        if (!tipologia.capacidad_max && !tipologia.dormitorios && !tipologia.banios && !tipologia.descripcion) {
          primeraVez.value = true;
          primeraVez.idTipologia = tipologia.id;
          tipologia.unidades.forEach(function (unidad) {
            primeraVez.idUnidad = unidad.id;
          });
        }
      });
    }

    this.state = {
      open: false,
      tipologias: this.props.tipologias,
      tipologiaSelected: null,
      primeraVez,
      openAlertEliminar: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tipologias != this.props.tipologias) {
      this.setState({
        tipologias: this.props.tipologias
      });
    }
  }

  openModal(value, idTipologia = null) {
    this.setState({
      open: value,
      tipologiaSelected: idTipologia
    });
  }

  guardar(tipologia) {
    this.openModal(false);
    let data = {
      id: tipologia.id,
      nombre: tipologia.nombre,
      capacidad_max: tipologia.capacidad_max,
      dormitorios: tipologia.dormitorios,
      banios: tipologia.banios,
      descripcion: tipologia.descripcion,
      unidades: tipologia.unidades
    };
    let accion = null;

    if (this.state.primeraVez.value) {
      //si entro por primera vez esta editando la tipologia y unidad que tiene
      accion = 1;
      this.setState({
        primeraVez: { ...this.state.primeraVez,
          value: false
        }
      });
    } else if (tipologia.new) {
      accion = 0;
    } else if (tipologia.edit) {
      accion = 1;
    } else if (tipologia.delete) {
      accion = 1;
      data = { ...data,
        delete: 1
      };
    }

    this.props.onChange(accion, data);
  }

  eliminarTipologia(idSelected) {
    if (this.state.tipologias.length > 1) {
      let tipologiaAEliminar = this.state.tipologias.find(t => t.id == idSelected);
      this.guardar({ ...tipologiaAEliminar,
        delete: 1
      });
    } else {
      this.setState({
        openAlertEliminar: true
      });
    }
  }

  onCancelarAlertEliminar() {
    this.setState({
      openAlertEliminar: false
    });
  }

  onAgregarTipologiaAlertEliminar() {
    this.setState({
      openAlertEliminar: false
    });
    this.openModal(true);
  }

  render() {
    const {
      open,
      tipologias,
      tipologiaSelected
    } = this.state;
    return (0, _react2.jsx)("div", {
      css: _style.default.root
    }, (0, _react2.jsx)(_material.Grid, {
      container: true
    }, tipologias.length && !this.state.primeraVez.value ? tipologias.map(t => {
      return (0, _react2.jsx)(_material.Grid, {
        item: true,
        key: t.id,
        css: _style.default.cardTipologia,
        xs: 12
      }, (0, _react2.jsx)(_CardTipologia.default, {
        id: t.id,
        titulo: t.nombre,
        capacidad: t.capacidad_max,
        dormitorios: t.dormitorios,
        banios: t.banios,
        unidades: t.unidades,
        openModal: this.openModal,
        eliminarTipologia: this.eliminarTipologia
      }));
    }) : (0, _react2.jsx)(_material.Grid, {
      container: true,
      justifyContent: "center"
    }, (0, _react2.jsx)("img", {
      src: _housesAnimate.default,
      css: _style.default.emptyStateHouses
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      css: _style.default.botonAgregarTipologia
    }, (0, _react2.jsx)(_material.Button, {
      onClick: () => this.openModal(true),
      variant: "outlined",
      color: "primary"
    }, "Agregar Tipolog\xEDa"))), (0, _react2.jsx)(_Modal.default, {
      open: this.state.openAlertEliminar,
      titulo: "No es posible eliminar.",
      texto: "Necesitas tener al menos una tipolog\xEDa cargada. Pero no te preocupes, agreg\xE1 una nueva y luego vas a poder deshacerte de esta!",
      botonCancelarTexto: "VOLVER",
      onCancelar: this.onCancelarAlertEliminar,
      botonAceptarTexto: "Agregar tipolog\xEDa",
      onAceptar: this.onAgregarTipologiaAlertEliminar
    }), open ? (0, _react2.jsx)(_FormTipologia.default, {
      open: open,
      tipologia: tipologiaSelected ? tipologias.find(t => t.id == tipologiaSelected) : null,
      openModal: this.openModal,
      guardar: this.guardar,
      primeraVez: this.state.primeraVez
    }) : null);
  }

}

exports.ContainerFormTipologia = ContainerFormTipologia;
var _default = ContainerFormTipologia;
exports.default = _default;